import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootState } from '../store/reducers';
import { Search, HelpCircle, Bell } from 'lucide-react';
import './TopBar.css';

const pageTitles: Record<string, { title: string; subtitle: string }> = {
  '/espace-cndj': { title: 'Tableau de bord', subtitle: "Vue d'ensemble de l'activité du centre" },
  '/espace-cndj/numerisation': { title: 'Numérisation', subtitle: 'Importer et traiter les décisions' },
  '/espace-cndj/decisions': { title: 'Décisions', subtitle: 'Gérer et publier les décisions' },
  '/espace-cndj/recherche': { title: 'Recherche avancée', subtitle: 'Explorer la base documentaire' },
  '/espace-admin': { title: 'Administration', subtitle: "Vue d'ensemble de la plateforme" },
  '/espace-admin/utilisateurs': { title: 'Utilisateurs', subtitle: 'Gérer les comptes et les rôles' },
  '/espace-admin/historique': { title: 'Historique de connexion', subtitle: 'Suivi des connexions et tentatives' },
};

const TopBar: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  const basePath = location.pathname.match(/^\/espace-(cndj|admin)(\/[^/]+)?/)?.[0] || '/espace-cndj';
  const isAdmin = location.pathname.startsWith('/espace-admin');
  const pageInfo = pageTitles[basePath] || (isAdmin ? pageTitles['/espace-admin'] : pageTitles['/espace-cndj']);

  const initials = user?.username
    ? user.username.charAt(0).toUpperCase()
    : 'U';

  const displayName = user?.username || 'Utilisateur';

  const roleLabel = user?.role === 'admin' ? 'Administrateur' : 'Agent CNDJ';

  return (
    <header className="topbar">
      <div className="topbar-left">
        <h1 className="topbar-title">{pageInfo.title}</h1>
        <p className="topbar-subtitle">{pageInfo.subtitle}</p>
      </div>

      <div className="topbar-right">
        <div className="topbar-search">
          <Search size={16} className="topbar-search-icon" />
          <input type="text" placeholder="Rechercher une décision..." />
        </div>

        <button className="topbar-icon-btn">
          <HelpCircle size={20} />
        </button>

        <button className="topbar-icon-btn topbar-notif-btn">
          <Bell size={20} />
          <span className="topbar-notif-dot" />
        </button>

        <div className="topbar-user">
          <div className="topbar-avatar">{initials}</div>
          <div className="topbar-user-info">
            <span className="topbar-user-name">{displayName}</span>
            <span className="topbar-user-role">{roleLabel}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
